import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { CommonButton } from '../../Components/common/commonButton';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Stack, Typography } from "@mui/material";
import { customDateFormat, getPaginationCount } from "../CashAllocation/utils";
import format from "date-fns/format";
import { CommonPaginationContainer } from "../common";
import { getAccountingMonths, downloadAccountingMonths } from "../../Services/api";
import instance from "../../redux/api";
import AddEditAccountingMonth from './AddEditAccountingMonth';
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import DialogBox from "../common/dialog";
import { commonToast } from '../common';
import {
  primaryButtonStyle,
  downloadButtonStyle,
  primaryButtonHoverColor,
} from "../common/commonButtonStyles";
import "../common/commonPageStyles.css";
// import { CommonSelect } from '../../';

import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";

const AccountingMonthList = () => {

  const classes = useStyles();
  const toggle = useSelector((state) => state.toggleSideMenu);
  const [accountingMonth, setAccountingMonth] = useState([])
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [openDeleteConfirmDialog, setOpenDeleteConfirmDialog] = useState(false);


  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });
  const [isOpenAccountingDialog, setIsOpenAccountingDialog] = useState(false);
  const [operationMode, setOperationMode] = useState();
  const [idToDelete, setIdToDelete] = useState(null);
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);


  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  useEffect(() => {
    setPaginationCount(getPaginationCount(pageState?.total, pageState?.pageSize));
  }, [pageState?.total]);

  useEffect(() => {
    loadData();
  }, [pageState?.pageSize, pageState?.page]);

  const loadData = async () => {
    try {
      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: true
      }));
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;
      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      }

      const response = await instance.get(`${getAccountingMonths}?${queryParams}`);

      console.log("Response : ", response)

      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: false
      }));

      if (response?.data) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.results ?? [],
        }));
        setPaginationCount(Math.floor(response?.data?.count / pageState?.pageSize));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  }

  const searchQueryParams = () => {
    return ""
  }

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    position: "relative",
  };

  const columns = [
    {
      field: "accounting_month_date",
      headerName: "Accounting Month",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <span>
          {params?.value ? format(params?.value, "MMM-yyyy") : ""}
        </span>
      ),
    },
    {
      field: "accounting_month_start_date",
      headerName: "Start Date",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <span>
          {params?.value ? customDateFormat(params?.value) : ""}
        </span>
      ),
    },
    {
      field: "accounting_month_end_date",
      headerName: "End Date",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <span>
          {params?.value ? customDateFormat(params?.value) : ""}
        </span>
      ),
    },
    {
      field: "created_by",
      headerName: "Created By",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <span>
          {params?.value?.user_name}
        </span>
      ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <span>
          {params?.value ? customDateFormat(params?.value) : ""}
        </span>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <>
          <EditIcon
            style={{ marginRight: 8, cursor: "pointer" }}
            titleAccess="Edit"
            onClick={() => handleEditMonth(params.row)}
          />

          <DeleteIcon
            style={{ marginRight: 8, cursor: "pointer", color: "red" }}
            titleAccess="Delete"
            onClick={() => handleDeleteMonth(params.row)}
          />
        </>

      ),
    }
  ];

  // const updateAccountingMonth = (data, mode) => {
  //   loadData()
  // }

  const handleAddBtnClick = () => {
    setIsOpenAccountingDialog(true);
    setOperationMode("ADD");
  }

  const handleEditMonth = (row) => {
    console.log("Row to edit : ", row)
    setAccountingMonth(row)
    setIsOpenAccountingDialog(true);
    setOperationMode("EDIT");
  }


  const handleDeleteCancelled = () => {
    setOpenDeleteConfirmDialog(false);
    setIdToDelete(null);
  };

  const handleDeleteConfirmed = () => {
    instance.delete(`${getAccountingMonths}${idToDelete}/`)
      .then((response) => {
        setOpenDeleteConfirmDialog(false);
        setIdToDelete(null);

        commonToast("success", "Accounting Month deleted successfully!");

        setPageState((old) => {
          const newData = old.data.filter((item) => item.id !== idToDelete)
          setPaginationCount(
            getPaginationCount(newData.length, old.pageSize)
          );
          return { ...old, data: newData, total: newData.length };
        });

      }).catch((error) => {
        setOpenDeleteConfirmDialog(false);
        setIdToDelete(null);
        console.log("Error From API : ", error)
        if (typeof error.data.message === 'string') {
          commonToast("error", error.data.message ?? "Unable to delete Accounting Month!");
        }
        else {

          error.data.message.forEach(message =>
            commonToast("error", message ?? "Unable to delete Accounting Month!")
          )
        }
      })
  };

  const handleDeleteMonth = (row) => {
    setOpenDeleteConfirmDialog(true);
    setIdToDelete(row.id);
  }
  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadAccountingMonths}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `AccountingMonthEnd_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Accounting Month End data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Accounting Month End data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Accounting Month End data could not be downloaded");
    }
  }

  return (
    <div style={Container}>
      {/* Main Content Area */}
      <Box className="main-content-area">
        <Box className="page-header-container">
          <Typography variant="h5" className="page-heading">
            Accounting Month List
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <CommonButton
              text="Add Accounting Month"
              handleClick={handleAddBtnClick}
              sx={primaryButtonStyle}
              hoverColor={primaryButtonHoverColor}
              disabled={pageState?.isLoading}
            />
            <CommonButton
              text="Export"
              handleClick={handleDownloadBtnClick}
              sx={downloadButtonStyle}
              hoverColor={primaryButtonHoverColor}
              disabled={isDownloadInProgress}
            />
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            position: "relative",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "visible",
            transition: "all 0.3s ease",
            border: "1px solid #e8eaf0",
            paddingBottom: "10px",
            width: "100%",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            },
          }}
        >
          <DataGrid
            className={classes.pagination}
            loading={pageState?.isLoading}
            rows={pageState?.data ?? []}
            columns={columns}
            rowCount={pageState?.total}
            keepNonExistentRowsSelected
            disableSelectionOnClick
            pagination
            paginationMode="server"
            getRowId={(row) => row?.id}
            page={pageState.page - 1}
            pageSize={pageState?.pageSize ?? 25}
            pageSizeOptions
            rowsPerPageOptions={[10, 25, 50, 100]}
            onPageSizeChange={(newPageSize) => {
              return setPageState((old) => {
                setPaginationCount(
                  getPaginationCount(pageState?.total, newPageSize)
                );
                return { ...old, pageSize: newPageSize, page: 1 };
              });
            }}
            sx={{
              border: "none",
              flex: 1,
              minHeight: 0,
              width: "100%",
              "& .MuiDataGrid-root": {
                border: "none",
                height: "100%",
                width: "100%",
              },
              "& .MuiDataGrid-main": {
                height: "100%",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "transparent",
                fontWeight: "600",
                color: "#1672DE",
                fontSize: "14px",
                padding: "12px 16px",
                borderBottom: "none",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-row": {
                borderBottom: "1px solid #f0f0f0",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafafa",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
                fontSize: "14px",
                color: "#333",
                padding: "12px 16px",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "2px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                minHeight: "48px",
                maxHeight: "48px",
                paddingBottom: "8px",
                paddingTop: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                position: "relative",
                zIndex: 1,
                "& .MuiTablePagination-root": {
                  color: "#666",
                  paddingRight: "16px",
                  margin: 0,
                  minHeight: "32px",
                },
                "& .MuiTablePagination-selectLabel": {
                  fontSize: "13px",
                  margin: 0,
                },
              },
            }}
            components={{
              Toolbar: () => null,
              NoRowsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                >
                  No Accounting Month available
                </Stack>
              ),
            }}
          />
          <Stack
            style={{
              position: "absolute",
              bottom: "8px",
              right: "16px",
            }}
          >
            <CommonPaginationContainer
              count={paginationCount + 1}
              pageState={pageState}
              setPageState={setPageState}
            />
          </Stack>
        </Box>
      </Box>
      {isOpenAccountingDialog && (
        <AddEditAccountingMonth
          operationMode={operationMode}
          setIsOpenAccountingDialog={setIsOpenAccountingDialog}
          accountingMonth={accountingMonth}
          updateAccountingMonth={loadData}
          latestMonth={pageState.data[0] ?? {}}
        />
      )}

      <DialogBox
        title="Delete Confirmation"
        body={`Are you sure you want to delete this Accounting Month?`}
        confirmText="Delete"
        isOpen={openDeleteConfirmDialog}
        onCancel={handleDeleteCancelled}
        onConfirm={handleDeleteConfirmed}
      // isDisableConfirm={isDeleteInProgress}
      />
    </div>
  )
}

export default AccountingMonthList
